import React from 'react';
import formatCurrency from '../../../../../utils/currencyFormatter';
import TokenIcon from '../../../../../components/TokenIcon';
import './style.scss';
import { identity } from '../../../../../utils/getIdentity';


const AdminCurrencyItem = ({ currency, setCurrency, currencyBalance, title }) => {

  return (
    <div
      className={`admin-withdraw-currency-item admin-withdraw-currency-item-${identity} ${
        currency === currencyBalance.currency.id && `admin-withdraw-currency-item_active admin-withdraw-currency-item_active-${identity}`
      }`}
      onClick={() => setCurrency(currencyBalance.currency.id)}
    >
      <div className="admin-withdraw-currency-item_left">
        <div className="currency-item__name-wrap">
          <TokenIcon className="admin-withdraw-currency-item__logo" tokenName={currencyBalance.currency.name} />
          <div className={`admin-withdraw-currency-item__title admin-withdraw-currency-item__title-${identity}`}>{title}</div>
        </div>
      </div>
      <div className="admin-withdraw-currency-item_right">
        <div className={`admin-withdraw-currency-item__amount admin-withdraw-currency-item__amount-${identity}`}>
          {currencyBalance.balance.value} {currencyBalance.currency.name}
        </div>
        <div className="admin-withdraw-currency-item__usd">{formatCurrency(currencyBalance.balance.usd)}</div>
      </div>
    </div>
  );
};

export default AdminCurrencyItem;
